export default [
  {
    link: 'http://avtoban.ru/page1/',
    label: 'Новости',
    title:
      'Завершена государственная экспертиза оптимизированной проектной документации по инвестиционному проекту ЦКАД-4',
    date: '12 марта 2019',
    description:
      'Изменения коснулись некоторых транспортных развязок, количества протяженности водопропускных труб и количества мостовых и искусственных сооружений. Обновленный проект включает более технологичную и долговечную конструкцию дорожной одежды.'
  },
  {
    link: 'http://avtoban.ru/page2/',
    label: 'Инвесторам',
    title:
      'В июне 2016 года «АВТОБАН-Финанс» впервые в истории Группы компаний «АВТОБАН» выпустил облигации на 3 млрд рублей. '
  }
];



// WEBPACK FOOTER //
// ./assets/scripts/mock/fake-search.js